import { Modal, Form, Input } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item
const { TextArea } = Input

function SchedulerDenyPermissionComponent(props) {
  const { form, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal {...rest}>
      <Form layout="vertical">
        <FormItem label="Reason of denial">
          {getFieldDecorator('reason', {
            rules: [
              {
                required: false,
              }
            ]
          })(<TextArea rows={7} />)}
        </FormItem>
      </Form>
    </Modal>
  )
}

export const SchedulerDenyPermissionModal = Form.create()(toClass(SchedulerDenyPermissionComponent))

SchedulerDenyPermissionComponent.propTypes = {
  form: PropTypes.any,
  type: PropTypes.string,
}
